// extracted by mini-css-extract-plugin
module.exports = {"create":"AddList_create__ovml7"};